<div class="container">
	<fieldset [disabled]="editable">
		<div class="mb-3">
			<mat-form-field
				class="w-100"
				matTooltip="Wyżwienie podstawowe oferowane w cenie wyjazdu, przy wybraniu danej opcji jest ono obligatoryjne dla uczestnika, a pozostałe warianty wyżywienia można uzupełnić w cennikach."
			>
				<mat-select
					id="board"
					name="board"
					[(ngModel)]="service.data.board"
					required
					[disabled]="editable"
					required
				>
					<mat-option [value]="item.id" *ngFor="let item of service.mockData.board">
						{{ item.name }}
					</mat-option>
				</mat-select>
				<mat-label for="board">Wybierz wyzywienie</mat-label>
			</mat-form-field>
		</div>
		<div
			class="mb-3"
			matTooltip="Znajdź przystanek dla konkretnej wycieczki po nazwie lub kraju (w przypadku objazdówek - kraj i nazwa objazdu; w przypadku pobytu - miasto z adresem), Nie możęsz wybrać przystanku który nie ma przystanku nadrzędnego (dzięki któremy powstaje pozycja w Sezonie). Np wybierz przystanek Splitska 11, który ma przystanek nadrżedny Chorwacja WYpoczynek. Dzięki czemu wszystkie produkty z tym przystankiem będą przypisane do Sezonu 'Chorwacja Wypoczynek' "
		>
			<ng-select
				id="stop"
				name="stop"
				[(ngModel)]="service.data.stop"
				[placeholder]="
					[2, 3].includes(service.data.productKind)
						? 'Przystanek docelowy zostanie wygenerowany po utworzeniu produktu'
						: 'Przystanek docelowy'
				"
				[disabled]="[2, 3].includes(service.data.productKind) || editable"
				[multiple]="false"
			>
				<ng-option [value]="item.id" *ngFor="let item of service.mockData.stops">
					{{ item.address }}
					<small>({{ item.location.name }})</small>
				</ng-option>
			</ng-select>
		</div>
		<div class="mb-3">
			<div
				class="w-100"
				matTooltip="Dla wycieczek objazdowych i weekendówek nie uzupełniamy, można zaznaczyć więcej nic jedno"
			>
				<app-select-multi
					placeholder="Wybierz udogodnienia"
					[options]="service.mockData.convenience"
					[selected]="service.data.conveniences"
				>
				</app-select-multi>
				<!-- <ng-select
					id="conveniences"
					name="conveniences"
					[(ngModel)]="service.data.conveniences"
					[disabled]="editable"
					[multiple]="true"
					placeholder="Wybierz udogodnienia"
					required
				>
					<ng-option
						[value]="item.id"
						*ngFor="let item of service.mockData.convenience"
					>
						{{ item.name }}
					</ng-option>
				</ng-select> -->
			</div>
		</div>
		<div *ngIf="![3, 1].includes(service.data.productKind)">
			<mat-form-field class="w-100" matTooltip="(jak bez noclegu wpisujemy 0)"
				><mat-label for="nights">Ilość noclegów</mat-label>
				<input matInput type="number" id="nights" name="nights" [(ngModel)]="service.data.nightsStay"
			/></mat-form-field>
		</div>
	</fieldset>
</div>
